var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg781X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "109px",
    viewBox: "0 0 160 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "78@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.471401,0.136739373 C120.793945,1.02347819 135.640852,7.39382266 145.684301,15.2690181 C159.305031,25.9492057 167.963701,52.0925095 149.208077,73.1627761 C121.704603,104.06047 25.6122123,117.948359 4.36586798,85.1557953 C-15.2803504,54.8329384 33.83335,-3.18507155 102.471401,0.136739373 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attitude-to-goals/2",
    transform: "translate(-108.000000, -155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 78,
    transform: "translate(108.000000, 155.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 4.346639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1EEEC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,50.1533608 L54.6923077,54.1533608 L57,58.1533608 L48,58.1533608 L48,65.1533608 L47,65.1533608 L47,50.1533608 L57,50.1533608 Z",
    id: "Combined-Shape",
    fill: "#CAC2BB",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,60.1533608 L139.692308,64.1533608 L142,68.1533608 L133,68.1533608 L133,75.1533608 L132,75.1533608 L132,60.1533608 L142,60.1533608 Z",
    id: "Combined-Shape",
    fill: "#CAC2BB",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    id: "Path-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.525096, 19.265893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0234738237,88.9473684 C1.1479759,87.8245614 12.9552477,69.9298246 35.4452892,35.2631579 L58.9393141,58.7368421 L97.7346358,0 L153.518007,94 C101.813919,97.0635992 67.7995516,98.3594219 51.4749038,97.887468 C13.5167151,96.7900775 -0.660070934,89.6298828 0.0234738237,88.9473684 Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M114.572515,5.15336084 C138.320759,5.15336084 157.572515,24.4051166 157.572515,48.1533608 C157.572515,71.9016051 138.320759,91.1533608 114.572515,91.1533608 C100.277134,91.1533608 87.6110554,84.1774834 79.7926792,73.4441272 C71.9751515,84.1774834 59.3090733,91.1533608 45.0136917,91.1533608 C21.2654474,91.1533608 2.01369168,71.9016051 2.01369168,48.1533608 C2.01369168,24.4051166 21.2654474,5.15336084 45.0136917,5.15336084 C59.3090733,5.15336084 71.9751515,12.1292382 79.7935277,22.8625945 C87.6110554,12.1292382 100.277134,5.15336084 114.572515,5.15336084 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-56",
    fill: "#F88184",
    points: "99.8333333 0 125.166667 0 119.320513 10 125.166667 20 99.8333333 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#F88184",
    fillRule: "nonzero",
    points: "101 5.5 101 30.5 100 30.5 100 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,33.5 C98,38.8333333 98.0202201,42.4797799 100.06066,44.4393398 C100.455194,44.8182346 101.054855,45.2484687 101.958939,45.7673139 L102.545328,46.0951012 L104.571985,47.173934 L105.297267,47.5676563 C107.380863,48.7188478 108.653448,49.6190192 109.635298,50.7746243 C111.20788,52.6255004 111.522732,54.8086375 110.341641,57.1708204 C109.386276,59.0815509 107.722197,60.1295471 105.386489,60.5446445 L105.054668,60.6002427 L104.726196,60.6480299 L104.395616,60.6882688 L104.057474,60.7212219 L103.706313,60.747152 L103.336679,60.7663218 L102.943116,60.7789939 L102.520167,60.7854309 L101.818715,60.7839703 L100.729679,60.7626517 L99.4249046,60.7211208 L98.13979,60.6737579 L97.1087814,60.6419242 L96.1344826,60.6208034 C91.7130296,60.5485283 88.9960845,60.8533457 85.9114581,61.9152211 C85.1405586,62.1806014 84.3901794,62.4903988 83.6582529,62.8478513 C82.2564798,63.5324382 81.32409,64.9103539 81.209854,66.4661744 C81.0325521,68.8809126 82.846353,70.9821787 85.2610907,71.159486 C92.8919644,71.7197823 100.804951,72 109,72 C118.26943,72 124.534144,75.7513254 126.309527,81.5616722 C127.955034,86.9469664 125.142515,92.6585435 119.557086,94.892715 L119.182252,95.0373706 L118.799695,95.1744118 C118.73525,95.1966216 118.670453,95.2185174 118.605287,95.2401006 L118.20975,95.3658621 L117.80463,95.4841983 L117.389183,95.5951852 L116.962665,95.6988983 C116.890615,95.7155819 116.818072,95.7319655 116.745022,95.7480508 L116.300503,95.8409952 L115.843054,95.9268552 C115.765694,95.940579 115.687764,95.9540108 115.609248,95.9671521 L115.131009,96.0425273 L114.637979,96.1110072 L114.129416,96.1726677 L113.604575,96.2275843 L113.062713,96.2758328 L112.503085,96.317489 L111.924947,96.3526285 L111.327557,96.381327 L110.71017,96.4036602 L110.072042,96.4197039 L109.074333,96.4321421 L108.025774,96.4308546 L106.923853,96.416097 L105.766061,96.3881247 L104.549885,96.3471933 L103.272817,96.2935583 L101.932346,96.2274752 L100.52596,96.1491995 L98.5439077,96.0263072 L95.3297301,95.8035034 L93.0175343,95.6302071 L87.7765054,95.2259296 L84.7127299,95.0056433 L82.8574019,94.8828529 L80.7309668,94.7566226 L79.1716139,94.6775707 L77.7272922,94.6181263 L77.0450924,94.5957894 L75.7542641,94.5659506 L74.8455159,94.5566033 L73.9828955,94.5584746 L73.4313247,94.5659762 L72.6360572,94.5866423 L72.1254189,94.6067142 L71.6289306,94.631837 L70.9079508,94.6790196 L70.4412803,94.7168259 L69.984314,94.7597283 L69.5357816,94.8077397 L69.0944129,94.8608731 L68.4430132,94.9502052 C68.3712134,94.9607744 68.2995797,94.9715585 68.2280858,94.9825575 C59.9604374,96.2545035 55,102.5 53,105.5 L46,105.5 C51.5663515,97.8462667 58.7062293,93.4121632 67.7719142,92.0174425 L68.2326122,91.9494746 L68.6965429,91.8869533 L69.1650598,91.8298595 L69.8793947,91.7543546 L70.3652981,91.7107476 L70.8605245,91.6725023 L71.3664274,91.6396 L72.1482604,91.6002233 L72.6867754,91.5805959 L73.2407037,91.5662456 L74.1034565,91.5545733 L75.008502,91.5546685 L76.2889128,91.5729905 L76.963742,91.589907 L78.0230717,91.6249233 L79.5305107,91.6895103 L81.5827125,91.7987978 L83.371992,91.9088873 L85.3041279,92.0389554 L90.2298338,92.4038756 L94.3901563,92.7255555 L97.130357,92.923156 L99.6650468,93.0894091 L101.552001,93.1992112 L102.888669,93.2677141 L104.160572,93.3241216 L105.370015,93.3682312 L106.519301,93.3998402 L107.610735,93.4187461 L108.307357,93.4241927 L109.307493,93.4214766 L109.945383,93.4123209 L110.560976,93.3972193 L111.154953,93.3761117 L112.006886,93.3330579 L112.814027,93.2761529 L113.328374,93.2304212 L113.824521,93.1783834 L114.303151,93.1199796 L114.764946,93.0551495 L115.210588,92.9838333 L115.640762,92.905971 L116.05615,92.8215024 L116.457434,92.7303676 C116.523177,92.7146196 116.588361,92.6985913 116.653,92.6822816 L117.03441,92.5810349 L117.403423,92.4729719 L117.760723,92.3580326 L118.106992,92.236157 L118.442914,92.107285 C122.593334,90.4471169 124.62619,86.3188564 123.440473,82.4383278 C122.089635,78.0174043 117.05057,75 109,75 C100.732855,75 92.7466735,74.7171903 85.041404,74.1514315 C80.9742608,73.8527928 77.9192787,70.3136336 78.2179083,66.246491 C78.410316,63.6260223 79.9807402,61.3051986 82.3417471,60.1521487 C83.1852898,59.740186 84.0492249,59.3835065 84.9349565,59.0785955 C88.2815682,57.9265323 91.1712671,57.5711143 95.5946259,57.6131212 L96.603649,57.6288357 L97.6680172,57.6566606 L99.8674326,57.7324465 L100.849676,57.7562566 L101.455411,57.7642957 L102.023519,57.7656443 L102.555411,57.7599398 C102.641121,57.7583811 102.72538,57.7565135 102.808218,57.7543293 L103.288435,57.7373651 L103.735966,57.7124413 L104.152223,57.6791952 C104.28592,57.6666859 104.41464,57.652729 104.538619,57.6372642 L104.896565,57.5862857 C104.95393,57.5770152 105.010169,57.5673526 105.065311,57.5572903 L105.38323,57.4920606 C106.604127,57.2114755 107.226953,56.6919929 107.658359,55.8291796 C108.551117,54.043665 107.956659,52.7767566 105.426032,51.1351934 L104.986257,50.8579773 L104.510164,50.5729042 L103.997293,50.2790551 L103.447181,49.9755109 L101.291379,48.8281154 L100.747095,48.528759 C99.4795239,47.8189193 98.6024239,47.2237442 97.9393398,46.5606602 C95.6398737,44.2611941 95.914033,40.4903166 98.4009711,35.2604151 L98.7378735,34.5699808 C98.9125695,34.2206276 99.0966103,33.8650709 99.289896,33.5033144 L99.6887641,32.7715356 C99.9768408,32.2529974 100.114243,33.2943626 100,33.5 Z",
    id: "Path-5",
    fill: "#F1EEEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(104.705250, 4.078859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 6.0626075,
    cy: 5.61352546,
    rx: 6.0626075,
    ry: 5.61352546
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 6.0626075,
    cy: 5.46383145,
    rx: 5.01474941,
    ry: 4.64328649
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 6.0626075,
    cy: 5.31413744,
    rx: 3.81719731,
    ry: 3.53444196
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 6.0626075,
    cy: 5.25869521,
    rx: 2.76933923,
    ry: 2.56420299
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 6.0626075,
    cy: 5.14226654,
    rx: 1.57178713,
    ry: 1.45535845
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 6.0626075,
    cy: 5.09236853,
    rx: 1,
    ry: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg781X);
export default __webpack_public_path__ + "static/media/78@1x.4a794dea.svg";
export { ForwardRef as ReactComponent };